import { RoutePath } from '@shared/constants/routing.constants';
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import { NotFoundPage } from '@views/PageNotFound/PageNotFound.tsx';
import Home from '@views/Home/Home';
import { PrivateRoute } from '@components/routing/PrivateRoute.tsx';

export type RoutePathDefinition = RouteObject;

const BaseLayout = lazy(() => import('@components/layouts/BaseLayout/BaseLayout'));
const EVSEDetails = lazy(() => import('@views/EVSEDetails/EVSEDetails.tsx'));
const Login = lazy(() => import('@views/AuthLogin/Login.tsx'));

export const routes: RoutePathDefinition[] = [
  {
    path: RoutePath.Base,
    element: (
      <PrivateRoute>
        <BaseLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: RoutePath.Base,
        element: <Home />,
      },
      {
        path: RoutePath.EVSEDetails,
        element: <EVSEDetails />,
      },
    ],
  },
  {
    path: RoutePath.Login,
    element: (
      <BaseLayout>
        <Login />
      </BaseLayout>
    ),
  },
  {
    path: RoutePath.All,
    element: <NotFoundPage />,
  },
];
